<template>
  <v-card class="fill-height" width="100vw" :loading="loading">
    <v-card-text>
      <v-card outlined>
        <v-card-text>
          <TextField label="Название корпорации"
            :original_value="original_value.name"
            v-model="corporation.name"
          />
        </v-card-text>
      </v-card>

      <v-card outlined class="mt-2">
        <v-card-title>
          Привязанные магазины
        </v-card-title>
        <v-card-text>
          <DataTable 
            :headers="headers"
            :items="shops"
            :total="total"
            @updateOptions="updateOptions"
            @onAdd="$emit('onAdd')"
            @onClickRow="onClickRow"
          />
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import TextField from '../ui/TextField.vue';
import DataTable from '../ui/DataTable.vue';

export default{
  props: {
    loading: Boolean,
    dealer: Object,
    original_value: Object,
    value: Object
  },

  data: () => ({
    search: "",
    options: {}
  }),

  computed: {
    corporation:{
      set(v){
        this.$emit('input', v)
      },
      get(){
        return this.value
      }
    },

    total(){
      return this.corporation?.shops ? this.corporation.shops.length : 0
    },

    shops(){
      return this.corporation?.shops ? this.corporation.shops : []
    },

    headers(){
      return [
        {text: '#', align: 'start', value: 'id'}, 
        {text: 'Название', align: 'start', value: 'name'},
        {text: 'Адрес', align: 'start', value: 'address'},
        {text: 'Настраивался', align:'start', value: 'prodelivery'},
        {text: 'Активен', align: 'start', value: 'enabled'},
        {text: 'Удален', align: 'start', value: 'deleted'}, 
      ]
    },
  },

  methods: {
    updateOptions(options){
      this.$emit('onGetList', {
        skip: options.page,
        limit: options.itemsPerPage,
        order_by: options.sortBy[0] ? options.sortBy[0] : null,
        direction: options.sortDesc[0] ? options.sortDesc[0] : null,
        include_deleted: options.include_deleted
      })
    },

    onClickRow(item){
      this.$emit('onClickRow', item);
    },

    onAdd(){
      this.$emit('onAdd', this.corporation);
    },
  },

  mounted(){
    // this.options = {
    //   sortBy: this.corporations.order_by ? this.corporations.order_by : [],
    //   sortDesc: this.corporations.direction ? this.corporations.direction : [],
    //   itemsPerPage: this.corporations.limit ? this.corporations.limit : 10,
    //   page: this.corporations.skip ? this.corporations.skip : 1,
    //   include_deleted: this.corporations.include_deleted ? this.corporations.include_deleted : false
    // }
  },

  components:{
    TextField,
    DataTable
  }
}
</script>